import { FC } from 'react';
import {
	ImageSizePriority,
	SpacerSectionBetweenColumns,
	TextHeadingSection,
} from 'components';
import { Col, Grid, Row } from 'antd';

export const SectionDescription: FC = () => {
	const { lg, xl } = Grid.useBreakpoint();

	return (
		<Row wrap={!lg} justify={'space-between'}>
			<Col flex={!lg && 'auto'}>
				<ImageSizePriority
					primaryPriority={'width'}
					switchBreakpoint={'lg'}
					src={'/assets/live-auction--description.png'}
				/>
			</Col>
			<Col flex={xl ? '544px' : lg && '448px'} lg={26}>
				<TextHeadingSection secondary>
					What are Live Auctions ?
				</TextHeadingSection>
				<p>
					Live auctions bring the fun and energy of rapid live auctions to the NFT ecosystem in a first of its kind application.
					All live auctions will be live streamed while members can chat in our troll box as they compete against one another to bid on only the most elusive and valuable NFTs.
					Auctions are hosted live by experienced NFT auctioneer Theo Goodman, who delivers an energizing, heart-pounding experience to Mint Gold Dust collectors.
					Have a rare piece you’ve been waiting to sell?
					Your moment is coming soon.
				</p>
			</Col>
		</Row>
	);
};
